import React, { type Dispatch, type FunctionComponent, type SetStateAction } from 'react'
import { SimpleSelect } from '@retailer-platform/shared-components'
import { type SimpleOption } from '@retailer-platform/shared-components/src/common/select/utils/select.types'
import styled from '@emotion/styled'
import { type Styles } from 'react-select'
import {
  type EligibilityOptions,
  type SubscriptionOptions,
} from 'domains/notifications/components/notifications-list/NotificationsList'

interface NotificationsFilterProps {
  placeholder?: string
  options: SimpleOption<string>[]
  selectedValue?: EligibilityOptions | SubscriptionOptions
  onChange: Dispatch<SetStateAction<null | EligibilityOptions | SubscriptionOptions>>
}

const FilterContainer = styled.div({
  marginRight: '1em',
})

const controlStyles: Styles = {
  control: () => ({ width: '150px' }),
}

export const NotificationsFilter: FunctionComponent<NotificationsFilterProps> = ({
  placeholder,
  options,
  selectedValue,
  onChange,
  ...rest
}) => (
  <FilterContainer>
    <SimpleSelect
      value={selectedValue}
      placeholder={placeholder}
      onChange={(e: EligibilityOptions | SubscriptionOptions) => onChange(e)}
      options={options}
      aria-label="notifications-list-filter-type"
      styles={controlStyles}
      {...rest}
    />
  </FilterContainer>
)
